import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Lo que más me gusta es lo fácil que es conseguir los materiales acá en Uruguay. El manual explica clarito cada paso para el brillo espejo y la verdad que me ahorró tiempo y plata. ¡Tremendo libro!',
  name: 'Martín S.',
  location: 'Montevideo',
  avatar: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  quote: 'Me encanta el bono de joyería. Nunca había trabajado con resina y ya hice mis primeros dijes para vender. Es una guía muy útil y los consejos para burbujas son la diferencia entre un desastre y un éxito.',
  name: 'Valentina G.',
  location: 'Maldonado',
  avatar: 'https://randomuser.me/api/portraits/women/26.jpg'
}, {
  quote: 'Bo, increíble la parte de los moldes caseros. Pensé que tenía que importar todo de afuera y al final con melamina y silicona de acá lo solucioné. La guía se paga sola con lo que ahorrás en materiales.',
  name: 'Gonzalo R.',
  location: 'Salto',
  avatar: 'https://randomuser.me/api/portraits/men/45.jpg'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function TestimonialsSection() {
  return <section className="py-[40px] md:py-[64px] px-5 bg-[#F7FAF9] relative" data-id="element-323">
      <div className="max-w-2xl mx-auto" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-[20px]" data-id="element-325">
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-[10px]" data-id="element-326">
            Resultados que hablan solos
          </h2>
          <p className="text-sm md:text-base text-gray-500 mt-3" data-id="element-327">
            Personas comunes que empezaron desde cero y hoy crean mesas
            profesionales
          </p>
          <div className="w-16 h-[3px] bg-[#A7D1C1] mx-auto mt-[10px]" data-id="element-328"></div>
        </motion.div>

        {/* WhatsApp Screenshots */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6" data-id="element-329">
          <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm bg-white" data-id="element-330">
            <img src="https://cdn.magicpatterns.com/uploads/kRQGo5XnnsQQ8BJJyNKJL5/WhatsApp_Image_2026-03-12_at_09.44.36.jpg" alt="Chat de WhatsApp — Andrés vendió su primera mesa premium" className="w-full object-cover object-top aspect-[3/4]" loading="lazy" data-id="element-331" />
          </div>
          <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm bg-white" data-id="element-332">
            <img src="https://cdn.magicpatterns.com/uploads/mPAkUZLkCWCJnKrmbdKK1Z/WhatsApp_Image_2026-03-12_at_09.44.38_(1).jpg" alt="Chat de WhatsApp — Valentina creó sus primeros aros de resina" className="w-full h-auto object-contain" loading="lazy" data-id="element-333" />
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="flex flex-col gap-3" data-id="element-334">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-xl border border-[#A7D1C1] p-5 w-full" data-id="element-335">
              {/* Stars */}
              <div className="flex gap-1 mb-3" data-id="element-336">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-[18px] h-[18px] text-[#4ADE80] fill-[#4ADE80]" data-id="element-337" />)}
              </div>

              {/* Quote */}
              <p className="text-[#333333] text-[15px] leading-[1.6] mb-4" data-id="element-338">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3" data-id="element-339">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover shrink-0" loading="lazy" width={40} height={40} data-id="element-340" />
                <div data-id="element-341">
                  <p className="font-bold text-[#333333] text-sm leading-tight flex items-center gap-1.5" data-id="element-342">
                    {testimonial.name}
                    <BadgeCheckIcon className="w-3.5 h-3.5 text-[#3B82F6] fill-[#3B82F6] shrink-0" data-id="element-343" />
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5" data-id="element-344">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}